// Decorated errors

export function invariant(message: string): never {
  throw new Error(`Invariant violation: ${message}.`)
}
